import React, { useState, useEffect } from 'react';
import Navbar from '../../../Components/Navbar/Navbar';
import {
    Layout,
} from 'antd';

function System36IndividualGame() {

    return (
        <Layout className='page'>
            <Navbar navKey={'system_36_individual_nav'} />
        </Layout>
    );
}

export default System36IndividualGame;